// utilidades removidas não utilizadas

export const useCategoryActions = (
  parameterType,
  syncId,
  selectedCategories,
  setSelectedCategories,
  configurations,
  setConfigurations,
  expandedCategories,
  setExpandedCategories,
  setSearchTerm,
  getTypeFromCategory,
  categoryTree,
  selectedType,
  onParametersChange,
  disabledCategoriesMap = {}
) => {
  // Função auxiliar para coletar todos os IDs descendentes recursivamente
  const collectAllDescendantIds = (category) => {
    const ids = [];
    
    const collectIds = (cat) => {
      if (cat.children && cat.children.length > 0) {
        cat.children.forEach(child => {
          const id = child.codCategoria || child.id;
          // Ignora itens desabilitados
          if (!disabledCategoriesMap[id]) {
            ids.push(id);
          }
          collectIds(child); // Recursão para netos, bisnetos, etc
        });
      }
    };
    
    collectIds(category);
    return ids;
  };

  // Função para alternar seleção de categoria pai (atualiza seleções e reflete no configurations do tipo atual)
  const handleCategoryToggle = (category) => {
    const categoryId = category.codCategoria || category.id;
    if (disabledCategoriesMap[categoryId]) return;

    const configKey = { dfc: 'dfcConfig', gruposFinanceiros: 'financialGroupConfig', indicadores: 'kpiConfig' }[parameterType];
    const typeField = { dfc: 'Type', gruposFinanceiros: 'FinancialGroup', indicadores: 'Type' }[parameterType];
    const getCfgType = (c) => Number(c.type ?? c.Type ?? c.financialGroup ?? c.FinancialGroup ?? -1);

    const descendantIds = collectAllDescendantIds(category);
    const affectedIds = [categoryId, ...descendantIds];

    setSelectedCategories(prev => {
      const next = { ...prev };
      const isSelected = !!next[categoryId];
      if (isSelected) {
        delete next[categoryId];
        descendantIds.forEach(id => delete next[id]);
      } else {
        next[categoryId] = true;
        descendantIds.forEach(id => (next[id] = true));
      }
      return next;
    });

    setConfigurations(prev => {
      const safe = prev || { dfcConfig: [], financialGroupConfig: [], kpiConfig: [], dreConfig: [] };
      const arr = safe[configKey] || [];
      const filtered = arr.filter(c => {
        const cat = c.codCategoria ?? c.CodCategoria;
        const t = getCfgType(c);
        return !(affectedIds.includes(cat) && Number(t) === Number(selectedType));
      });

      const wasSelecting = !!selectedCategories[categoryId] === false; // estado antes da atualização
      const additions = wasSelecting ? affectedIds.map(id => {
        const existingAny = arr.find(c => (c.codCategoria ?? c.CodCategoria) === id);
        return {
          Id: existingAny?.Id ?? existingAny?.id ?? null,
          [typeField]: Number(selectedType),
          CodCategoria: id,
          SyncId: syncId || null
        };
      }) : [];

      const nextArr = [...filtered, ...additions];
      return { ...safe, [configKey]: nextArr };
    });
  };

  // Função para alternar seleção de categoria filha (reflete em configurations do tipo atual)
  const handleChildToggle = (child) => {
    const childId = child.codCategoria || child.id;
    if (disabledCategoriesMap[childId]) return;

    const configKey = { dfc: 'dfcConfig', gruposFinanceiros: 'financialGroupConfig', indicadores: 'kpiConfig' }[parameterType];
    const typeField = { dfc: 'Type', gruposFinanceiros: 'FinancialGroup', indicadores: 'Type' }[parameterType];
    const getCfgType = (c) => Number(c.type ?? c.Type ?? c.financialGroup ?? c.FinancialGroup ?? -1);

    setSelectedCategories(prev => {
      const next = { ...prev };
      const isSelected = !!next[childId];
      if (isSelected) delete next[childId]; else next[childId] = true;
      return next;
    });

    setConfigurations(prev => {
      const safe = prev || { dfcConfig: [], financialGroupConfig: [], kpiConfig: [], dreConfig: [] };
      const arr = safe[configKey] || [];
      const filtered = arr.filter(c => {
        const cat = c.codCategoria ?? c.CodCategoria;
        const t = getCfgType(c);
        return !(cat === childId && Number(t) === Number(selectedType));
      });
      const wasSelecting = !selectedCategories[childId];
      const addition = wasSelecting ? (() => {
        const existingAny = arr.find(c => (c.codCategoria ?? c.CodCategoria) === childId);
        return {
          Id: existingAny?.Id ?? existingAny?.id ?? null,
          [typeField]: Number(selectedType),
          CodCategoria: childId,
          SyncId: syncId || null
        };
      })() : null;
      const nextArr = addition ? [...filtered, addition] : filtered;
      return { ...safe, [configKey]: nextArr };
    });
  };

  // Função para alternar expansão de categoria
  const toggleExpanded = (categoryId) => {
    const id = categoryId.codCategoria || categoryId.id || categoryId;
    setExpandedCategories(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  // Função para lidar com mudança na busca
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    
    // Se a busca foi limpa, contrair todas as categorias
    if (!value) {
      setExpandedCategories({});
    }
  };

  // Função utilitária para normalizar texto (remover acentos e caixa)
  const normalizeText = (text) =>
    text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

  // Função para filtrar categorias baseado na busca
  const getFilteredCategories = (categories, searchTerm) => {
    if (!searchTerm) return categories;
    
    const normalizedSearch = normalizeText(searchTerm);
    
    const filterCategory = (category) => {
      const normalizedName = normalizeText(category.nome || category.descricao || '');
      const matchesName = normalizedName.includes(normalizedSearch);
      
      // Se tem filhos, verifica se algum filho corresponde
      if (category.children && category.children.length > 0) {
        const filteredChildren = category.children.filter(filterCategory);
        if (filteredChildren.length > 0) {
          return {
            ...category,
            children: filteredChildren
          };
        }
      }
      
      return matchesName ? category : null;
    };
    
    return categories
      .map(filterCategory)
      .filter(Boolean);
  };

  return {
    handleCategoryToggle,
    handleChildToggle,
    toggleExpanded,
    handleSearchChange,
    getFilteredCategories
  };
};